import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "@/core/services/url-handler.service";

const WithdrawalsApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  async get(resource, slug = "") {
    return Vue.axios.get(this.URL + `${resource}/${slug}`).catch(error => {
      throw new Error(`[KT] WalletApiService ${error}`);
    });
  },

  getFile(resource, slug = "") {
    return Vue.axios
      .get(this.URL + `${resource}/${slug}`, {
        responseType: "blob"
      })
      .catch(error => {
        throw new Error(`[KT] WalletApiService ${error}`);
      });
  },

  /**
   * Get withdraw operations
   * @param params can be null or object with page | maxCount | status | date
   * Status can be: Processing, SendedToBank, ReturnedToWallet, Paid
   * @returns {*}
   */
  getWithdrawOperations(params) {
    return Vue.axios.get(this.URL + `api/promo/v1/revenueTracker/WithdrawOperations`, {
      params: { ...params, ignoreCountryId: true }
    });
  },

  /**
   * Move operations to Pending Payment
   * @param operationIds array of operation ids
   * @returns {*}
   */
  moveToPendingPayment(operationIds) {
    return Vue.axios.post(
      this.URL + `api/promo/v1/revenueTracker/MoveToPendingPayment`,
      {
        operationIds
      },
      { ignoreCountryId: true }
    );
  },

  /**
   * Mark withdraw operation as paid
   * @param operationIds array of operation ids
   * @returns {*}
   */
  markWithdrawOperationAsPaid(operationIds) {
    return Vue.axios.post(
      this.URL + `api/promo/v1/revenueTracker/MarkWithdrawsAsPaid`,
      {
        operationIds
      },
      { ignoreCountryId: true }
    );
  },

  /**
   * Cancel withdraw operation
   * @param operationIds array of operation ids
   * @returns {*}
   */
  cancelWithdrawOperation(operationIds) {
    return Vue.axios.post(
      this.URL + `api/promo/v1/revenueTracker/CancelProcessingWithdraws`,
      {
        operationIds
      },
      { ignoreCountryId: true }
    );
  },

  /**
   * Get withdraw file
   * @param operationIds withdraw operation id
   * @returns {*}
   */
  getWithdrawFile(operationIds) {
    let params = {
      ignoreCountryId: true
    };

    if (operationIds && operationIds.length > 0) {
      params.operationIds = operationIds;
    }

    return Vue.axios
      .get(this.URL + `api/promo/v1/revenueTracker/GenerateSctSammelbuchungXml`, {
        params: params,
        paramsSerializer: function(params) {
          const searchParams = new URLSearchParams();
          for (const key in params) {
            const value = params[key];
            if (Array.isArray(value)) {
              value.forEach(item => searchParams.append(key, item));
            } else if (value !== null && value !== undefined && value !== "") {
              searchParams.append(key, value);
            }
          }
          return searchParams.toString();
        },
        responseType: "blob"
      })
      .catch(error => {
        throw new Error(`[KT] WithdrawalsApiService ${error}`);
      });
  },

  /**
   * Get withdraw dashboard
   * @param {string} dateTime - Optional dateTime filter (ISO string)
   * @returns {*}
   */
  getWithdrawDashboard(dateTime = null) {
    let url = this.URL + `api/promo/v1/revenueTracker/Dashboard`;

    if (dateTime) {
      url += `?dateTime=${encodeURIComponent(dateTime)}`;
    }

    return Vue.axios.get(url);
  }
};

export default WithdrawalsApiService;
